import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

const isEmpty = value => value === null || value === undefined || value === ''

export class ShowLastCallRequestValueObject extends ValueObject {
  #adId
  #makeId
  #userId
  #offerTypeId

  constructor({adId, makeId, userId, offerTypeId}) {
    super()
    this.#adId = adId
    this.#makeId = makeId
    this.#userId = userId
    this.#offerTypeId = offerTypeId
  }

  static validate({adId, makeId, userId, offerTypeId}) {
    if (isEmpty(adId) || isEmpty(makeId) || isEmpty(userId) || isEmpty(offerTypeId)) {
      throw InvalidParamsSharedError.create(
        '[ShowLastCallRequestValueObject.validate] param adId, makeId, userId and offerTypeId are required'
      )
    }
  }

  static create({adId, makeId, userId, offerTypeId}) {
    ShowLastCallRequestValueObject.validate({adId, makeId, userId, offerTypeId})
    return new ShowLastCallRequestValueObject({
      adId,
      makeId,
      userId,
      offerTypeId
    })
  }

  get adId() {
    return this.#adId
  }

  get makeId() {
    return this.#makeId
  }

  get userId() {
    return this.#userId
  }

  get offerTypeId() {
    return this.#offerTypeId
  }

  toJSON() {
    return {
      adId: this.#adId,
      makeId: this.#makeId,
      userId: this.#userId,
      offerTypeId: this.#offerTypeId
    }
  }
}
